export type ThemePreference = 'light' | 'dark' | 'system'
export const DASHBOARD_THEME_KEY = 'barmanager-dashboard-theme'

export function isThemePreference (value: unknown): value is ThemePreference {
  return value === 'light' || value === 'dark' || value === 'system'
}

export function parseThemePreference (value: string | null): ThemePreference {
  return isThemePreference(value) ? value : 'light'
}

// Runs in the head before paint. The preference belongs only to the owner dashboard.
export const dashboardThemeScript = `(()=>{if(!new RegExp('^/(en|es)/dashboard(?:/|$)').test(location.pathname))return;let p='light';try{p=localStorage.getItem('${DASHBOARD_THEME_KEY}')||'light'}catch{}document.documentElement.dataset.theme=(p==='dark'||(p==='system'&&matchMedia('(prefers-color-scheme: dark)').matches))?'dark':'light'})()`
